import { AfterViewInit, Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-signature-pad',
  templateUrl: './signature-pad.component.html',
  styleUrls: ['./signature-pad.component.css']
})
export class SignaturePadComponent implements OnInit, AfterViewInit {
  @ViewChild('sigPad') sigPad: ElementRef<HTMLCanvasElement>;
  sigPadElement: any;
  context: any;
  isDrawing = false;
  isClear = true;
  signatureImage: string;

  constructor(public dialogRef: MatDialogRef<SignaturePadComponent>) { }

  ngOnInit() {
  }

  // The <canvas> reference (a non-static @ViewChild) is only available after the view is
  // initialised in Angular 9+. Initialising the 2D context here (not in ngOnInit) is what
  // makes drawing/saving work — otherwise this.sigPad is undefined and the pad is unusable.
  ngAfterViewInit() {
    this.sigPadElement = this.sigPad.nativeElement;
    this.context = this.sigPadElement.getContext('2d');
    this.context.strokeStyle = '#000000';
  }

  @HostListener('document:mouseup', ['$event'])
  @HostListener('document:touchend', ['$event'])
  onMouseUp(e) {
    this.isDrawing = false;
  }

  onMouseDown(e) {
    this.startStroke(e);
  }

  onMouseMove(e) {
    this.drawStroke(e);
  }

  // Touch equivalents (tablets/phones). preventDefault stops the browser from
  // scrolling/zooming the page while the user is signing.
  onTouchStart(e) {
    e.preventDefault();
    this.startStroke(e);
  }

  onTouchMove(e) {
    e.preventDefault();
    this.drawStroke(e);
  }

  private startStroke(e) {
    this.isDrawing = true;
    const coords = this.relativeCoords(e);
    this.context.beginPath();
    this.context.moveTo(coords.x, coords.y);
    this.isClear = false;
  }

  private drawStroke(e) {
    if (this.isDrawing) {
      const coords = this.relativeCoords(e);
      this.context.lineTo(coords.x, coords.y);
      this.context.stroke();
    }
  }

  // Works for both mouse and touch events. Uses the canvas bounds (not event.target)
  // so coordinates stay correct regardless of which element the touch reports.
  private relativeCoords(event) {
    const bounds = this.sigPadElement.getBoundingClientRect();
    const point = (event.touches && event.touches.length) ? event.touches[0] : event;
    const x = point.clientX - bounds.left;
    const y = point.clientY - bounds.top;
    return { x: x, y: y };
  }

  clear() {
    this.context.clearRect(0, 0, this.sigPadElement.width, this.sigPadElement.height);
    this.context.beginPath();
    this.signatureImage = '';
    this.isClear = true;
  }

  save() {
    this.signatureImage = this.sigPadElement.toDataURL("image/png");
    if (this.isClear == true) {
      this.signatureImage = '';
    }
    this.dialogRef.close({ Status: true, SignatureImage: this.signatureImage });
  }

  onclose(): void {
    this.dialogRef.close();
  }

}
